import { FC } from "react";

const CustomRuleList: FC = () => {
  return (
    null
  )
}

export default CustomRuleList;
